<template>
  <div class="image-container">
    <v-img
      v-if="src"
      :class="{ bordered: bordered, 'image-container': true }"
      :src="src"
      :style="{}"
      contain
      @mouseenter="bar = true"
      @mouseleave="bar = false"
      @mousedown="startRect"
      @mousemove="createRect"
      @mouseup="finishRect"
    >
      <div v-if="isRegisteredForDeletion" class="fill-height repeating-gradient" />
      <v-layout slot="placeholder" align-center fill-height justify-center ma-0>
        <loading-screen :is-loading="true" />
      </v-layout>
      <slot class="overlay" name="image-overlay" :hover="bar" :src="src" />
      <template v-if="highlightTexts && texts && texts.editAreas && texts.editAreas.length > 0">
        <div
          v-for="rect in texts.editAreas"
          :key="rect._id"
          class="text-rect"
          :style="`left: ${rect.x}%; top: ${rect.y}%; width: ${rect.width}%; height: ${rect.height}%;`"
        />
      </template>
      <template v-if="interactionMode === true && withInteraction">
        <div
          :style="`left: ${item.x}px; top: ${item.y}px; width: ${item.width}px; height: ${item.height}px;`"
          class="interaction"
        />
        <div
          v-for="interaction in interactions"
          v-if="interaction.from.asset._id === $store.state.slides.active._id"
          :key="interaction._id"
          :class="`interaction ${activeInteraction._id === interaction._id ? 'active' : ''}`"
          :style="
            `left: ${interaction.from.coord.x}%; top: ${interaction.from.coord.y}%; width: ${interaction.from.coord.w}%; height: ${interaction.from.coord.h}%;`
          "
          @mouseenter="setInteractionActive(interaction)"
        />
        <v-dialog v-model="dialog" content-class="no-shadow" width="400px" light persistent>
          <create-interaction-dialog @close="dialog = false" />
        </v-dialog>
      </template>
      <template v-if="seeTasks">
        <task-pointer
          v-for="task in activeTasks"
          :id="task._id"
          :key="task._id"
          :active="activeTask === task._id"
          :author="task.data.author"
          :content="task.data.text"
          :geometry="task.geometry"
        />
      </template>
    </v-img>
    <slot class="overlay" name="bottom-overlay" :hover="bar" :src="src" />
  </div>
</template>

<script>
import LoadingScreen from '@/components/loading-screen/LoadingScreen';
import TaskPointer from '@/components/img/tasks/task-pointer';
import { ReactInVue } from 'vuera';
import Annotation from 'react-image-annotation';
import { mapState } from 'vuex';
import InteractionEventMixin from '@/mixins/InteractionEventMixin';
import CreateInteractionDialog from '@/components/dialogs/CreateInteractionDialog';
import { INTERACTION_SET_ACTIVE } from '../../config/constants';

export default {
  name: 'ImageHelper',
  components: {
    CreateInteractionDialog,
    TaskPointer,
    LoadingScreen,
    annotation: ReactInVue(Annotation)
  },
  mixins: [InteractionEventMixin],
  props: {
    src: {
      type: String | null,
      required: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    timetravel: {
      type: Boolean,
      default: false
    },
    withInteraction: {
      type: Boolean,
      default: false
    },
    tasks: {
      type: Array
    },
    seeTasks: {
      type: Boolean,
      default: false
    },
    activeTask: {
      type: String
    },
    history: {
      type: Array
    },
    isRegisteredForDeletion: {
      type: Boolean,
      default: false
    },
    tile: {
      type: Boolean
    },
    highlightTexts: Boolean
  },
  data() {
    return {
      bar: false
    };
  },
  methods: {
    setInteractionActive(interaction) {
      this.$store.commit(INTERACTION_SET_ACTIVE, interaction);
    }
  },
  computed: {
    ...mapState('slides', {
      texts: state => state.texts.activeText
    }),
    ...mapState('interactions', {
      interactions: state => state.items,
      activeInteraction: state => state.active
    }),
    activeTasks() {
      return this.tasks.filter(x => x.status.step !== 'done');
    },
    historyArray: function() {
      return [
        this.src,
        ...this.history.map(
          id => `https://www.googleapis.com/download/storage/v1/b/slides-png/o/${id}.jpeg?alt=media`
        )
      ];
    }
  }
};
</script>

<style scoped>
.image-container {
  border-radius: inherit;
}
.bordered {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.test {
  box-shadow: none !important;
}

.text-rect {
  position: absolute;
  background-color: var(--new-blue);
  opacity: 0.4;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.interaction {
  position: absolute;
  border: 1px dashed grey;
  background-color: rgba(0, 65, 110, 0.5);
}

.content-card {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.active {
  border-color: red;
  border-style: solid;
}

.repeating-gradient {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.25),
    rgba(255, 255, 255, 0.25) 5px,
    rgba(0, 0, 0, 0.25) 5px,
    rgba(0, 0, 0, 0.25) 10px
  );
}
</style>
